import PageHeader from '@components/layout/page-header.jsx';
import ItemCard from '@components/shared/cards/item.card.jsx';
import { useMetaTags } from 'react-metatags-hook';
import { isTestMode } from '@util/const.js';
import { overlays } from '@data/overlays.jsx';

const description = `CCAM-enabled overlays and progress bars for St. Jude Play Live Tools.`;

export default function CCAMToolsPage() {
  const link = { title: 'CCAM Tools' };

  useMetaTags(
    {
      title: `CCAM Tools | ${isTestMode ? '' : 'St. Jude '}Play Live Tools`,
      description,
      openGraph: {
        description,
      },
    },
    [description, name]
  );
  const items = [overlays.min, overlays.max, overlays.vertical, overlays.basic];

  return (
    <div className="h-full w-full min-h-screen-nav overflow-x-hidden flex flex-col items-start lg:px-3">
      <div className="flex flex-col max-w-screen-2xl w-full overflow-hidden pt-5 pb-10">
        <PageHeader
          className="ml-6"
          name="CCAM Tools"
          description={description}
          links={[link]}
        />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:ml-6 md:mr-2 mr-2 ml-2">
          {items.map((item, index) => (
            <ItemCard
              isFirst={index === 0}
              isLast={index === items.length - 1}
              key={item.type}
              name={item.name}
              link={item.link}
              thumbnail={item.thumbnail}
              description={item.shortDescription ?? item.description}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
